import { PhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js/min';

export const phoneNumberFromString = (phoneNumber: string): PhoneNumber | null => {
    const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber);
    if (parsedPhoneNumber === undefined) {
        return null;
    }

    return parsedPhoneNumber;
};

export const validatePhoneNumber = (phoneNumber: PhoneNumber | null): boolean => {
    return phoneNumber !== null && phoneNumber.isValid();
};

export const getMaskedPhoneNumber = (phoneNumber: string | null | undefined): string => {
    if (!phoneNumber) {
        return '';
    }

    const parsedPhoneNumber = phoneNumberFromString(phoneNumber);
    if (!parsedPhoneNumber || !parsedPhoneNumber.isValid()) {
        return phoneNumber;
    }

    const countryCallingCode = `+${parsedPhoneNumber.countryCallingCode}`;
    const { nationalNumber } = parsedPhoneNumber;
    const maskedDigits = '•'.repeat(nationalNumber.length);

    return `${countryCallingCode}${maskedDigits}`;
};

export const isTwilioSDKSupported = (): boolean => {
    const { userAgent } = navigator;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isMacOS = /Mac OS X/.test(userAgent);
    const isChrome =
        (/Chrome/.test(userAgent) || /CriOS/.test(userAgent)) && !/Edg/.test(userAgent);
    const isFirefox = /Firefox/.test(userAgent) || /FxiOS/.test(userAgent);
    const isSafari =
        /Safari/.test(userAgent) && !/Chrome/.test(userAgent) && !/CriOS/.test(userAgent);
    const isEdge = /Edg/.test(userAgent);

    return (
        (isChrome && !isIOS) || (isFirefox && !isIOS) || (isSafari && (isIOS || isMacOS)) || isEdge
    );
};
